import { Grid } from "@mui/material";
import { DateFilter, ReceiptList } from "../../../../../Components/Molecules";
import { PaperHeader } from "../../../Receipts/styles";

type Props = {
  matches: boolean;
  subAccountData: any;
  loading: any;
  handleSetToFirstPage: () => void;
  handleChangePage: (e: any, v: number) => void;
  page: number;
};

const ExtratoSection = ({ matches, subAccountData, loading, handleSetToFirstPage, handleChangePage, page }: Props) => (
  <Grid>
    <PaperHeader style={{ flexDirection: matches ? "row" : "column" }}>
      {subAccountData !== undefined && (
        <DateFilter tableName={"extract"} setPageToFirst={handleSetToFirstPage} hasData={Object.keys(subAccountData).length > 0} />
      )}
    </PaperHeader>
    <ReceiptList itens={subAccountData} loading={loading.GET} type="extract" title="" headerLink={""} hasFilter={""} handleChangePage={handleChangePage} page={page} />
  </Grid>
);

export default ExtratoSection;
